<template>
  <div v-if="!$route.meta.closed" class="navbar">
    <!-- <hamburger :is-active="sidebar.opened" class="hamburger-container" @toggleClick="toggleSideBar" />
    <breadcrumb class="breadcrumb-container" /> -->
    <div class="right-menu">
      <div class="cu">软件版本：V1.20 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <span v-if="loginStatuss">欢迎！{{ $store.state.app.cu }}
          <i class="cursor" @click="loginOut">注销</i></span>
        <span v-else class="cursor" @click="loginIn">登录/注册</span>&nbsp;&nbsp;&nbsp;
        &nbsp;&nbsp;&nbsp;
        <!-- <el-dropdown @command="handleCommand">
        <span v-if="$route.meta.closed" class="el-dropdown-link">
          <span v-if="$i18n.locale=='cn'">中文</span>
          <span v-else>英文</span>
          <i class="el-icon-arrow-down el-icon--right" />
        </span>
        <el-dropdown-menu v-if="$route.meta.closed" slot="dropdown">
          <el-dropdown-item command="cn">中文</el-dropdown-item>
          <el-dropdown-item command="en">英文</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown></div>-->

      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import {
  removeToken
} from '@/utils/auth' // get token from cookie
import {
  logoutCas
} from '@/utils/logoutCas' // get token from cookie
export default {
  components: {
    Breadcrumb,
    Hamburger
  },
  data() {
    return {
      loginStatuss: '',
      activeIndex: '1',
      options: [{
        value: '选项1',
        label: '黄金糕'
      }, {
        value: '选项2',
        label: '双皮奶'
      }, {
        value: '选项3',
        label: '蚵仔煎'
      }, {
        value: '选项4',
        label: '龙须面'
      }, {
        value: '选项5',
        label: '北京烤鸭'
      }],
      value: '',
      cu: 'cas'
    }
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'avatar'
    ])
  },
  created() {
    this.getZw()
    this.loginStatuss = this.$store.state.app.cu
  },
  mounted() {
  },
  methods: {
    loginIn() {
      // window.location.href = process.env.VUE_APP_CAS_LOGIN_BACK
    },
    loginOut() {
      this.$confirm('是否确定注销?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        removeToken()
        this.loginStatuss = ''
        window.sessionStorage.setItem('cu', '')
        window.sessionStorage.setItem('userID', '')
        logoutCas(process.env.VUE_APP_CAS_LOGOUT_URL_BACK, true)
      }).catch(() => {
      })
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath)
    },
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },
    getZw() {

    },
    handleCommand(value) {
      localStorage.setItem('user_lang', value)
      this.$i18n.locale = value// 改变当前语言
      // localStorage.language = value
    }
  }
}
</script>

<style lang="scss" scoped>
// #app .hideSidebar .el-submenu>.el-submenu__title .el-submenu__icon-arrow{
//   display: block;
// }
// .right-menu.el-menu--popup{
//   width:180px;
// }
// .el-input__inner{
//   border: 1px solid white;
//   outline:none;
// }

	.user-dropdown {
		top:55px
	}
  .cu {
    // display:inline-block;
    font-size: 14px;
    line-height: 15px;
    position: absolute;
    right: 22px;
    top: 19px;
    .cursor{
      color:#409EFF
    }
    .cursor:hover{
      text-decoration: underline;
    }
  }

  .navbar {
    height: 50px;
    overflow: hidden;
    position: relative;
    background: #fff;
    border-bottom:2px solid #e8e8e8;
    box-shadow: 0 1px 4px rgba(0, 21, 41, .08);

    .hamburger-container {
      line-height: 46px;
      height: 100%;
      float: left;
      cursor: pointer;
      transition: background .3s;
      -webkit-tap-highlight-color: transparent;

      &:hover {
        background: rgba(0, 0, 0, .025)
      }
    }

    .breadcrumb-container {
      float: left;
    }

    .right-menu {
      width:20%;
      float: right;
      height: 100%;
      line-height: 50px;

      &:focus {
        outline: none;
      }

      .right-menu-item {
        display: inline-block;
        padding: 0 8px;
        height: 100%;
        font-size: 18px;
        color: #5a5e66;
        vertical-align: text-bottom;

        &.hover-effect {
          cursor: pointer;
          transition: background .3s;

          &:hover {
            background: rgba(0, 0, 0, .025)
          }
        }
      }

      .avatar-container {
        margin-right: 30px;

        .avatar-wrapper {
          margin-top: 5px;
          position: relative;

          .user-avatar {
            cursor: pointer;
            width: 40px;
            height: 40px;
            border-radius: 10px;
          }

          .el-icon-caret-bottom {
            cursor: pointer;
            position: absolute;
            right: -20px;
            top: 25px;
            font-size: 12px;
          }
        }
      }
    }
  }
   .el-dropdown-link {
    cursor: pointer;
    color: #409EFF;
  }
  .el-icon-arrow-down {
    font-size: 12px;
  }
</style>



// WEBPACK FOOTER //
// src/layout/components/Navbar.vue